<template>
  <div>
    <el-link type="primary" @click="url = 'https://zhnyg.farm.xiaomaiot.com'">
      环境监测物联网
    </el-link>
    <el-link
      type="warning"
      @click="url = 'https://api.satlic.net:8020/ManageNav/#/'"
    >
      水肥一体化管控
    </el-link>
    <iframe
      :src="url"
      frameborder="0"
      style="width: 100%; height: 820px; margin-top: 5px"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: 'https://zhnyg.farm.xiaomaiot.com',
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/monitor/environment/bozhou.vue